module.exports = __webpack_public_path__ + "static/media/brothers.6a4e93dd.jpg";